type SponsoredPlacementType = 'header' | 'teaser';
type DeviceType = 'mobile' | 'desktop';

export const getSponsoredPlacementMinimumProducts = (
  placement: SponsoredPlacementType,
  device: DeviceType,
) => {
  if (placement === 'header') {
    return device === 'mobile' ? 2 : 5;
  }

  return device === 'mobile' ? 4 : 3;
};

export const hasEnoughSponsoredProducts = ({
  placement,
  device,
  count,
}: {
  placement: SponsoredPlacementType;
  device: DeviceType;
  count: number;
}) => {
  return count >= getSponsoredPlacementMinimumProducts(placement, device);
};
